import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

import Loading from "../../../components/shared/Loading";
import PageContainer from "../../../components/template/PageContainer";
import {
  parseNonEmptyParams,
  parseProjectSearch,
  protectedLeaf,
} from "../../../router/route-contracts";

const Screen = lazy(() => import("../../../views/projects/Project"));

export const Route = createFileRoute("/_protected/projects/$projectId")({
  component: RouteComponent,
  validateSearch: parseProjectSearch,
  params: {
    parse: parseNonEmptyParams,
  },
  staticData: protectedLeaf({
    requiredRoles: [],
    routeKey: "projects",
    access: "protected",
    layout: "modern",
    container: "default",
  }),
});

function RouteComponent() {
  return (
    <Suspense fallback={<Loading loading={true} />}>
      <PageContainer
        pageContainerType={Route.options.staticData?.container}
        footer={Route.options.staticData?.footer}
      >
        <Screen />
      </PageContainer>
    </Suspense>
  );
}
